module.exports = __webpack_public_path__ + "img/inline-icon.bc38877d.svg";